import clsx from "clsx"
import { FC } from "react"
import { TermsOfUseContent } from "@/ui/TermsOfUseContent"
import styles from "./TermsOfUse.module.scss"

export const TermsOfUse: FC = () => (
  <div className={clsx(styles.TermsOfUse)}>
    <div className={clsx(styles.TermsOfUse_content)}>
      <TermsOfUseContent />
    </div>
  </div>
)
